module.exports = __webpack_public_path__ + "assets/fonts/HYZongYiTiJ.1189b659.ttf";